import React from 'react';
import { Label, Loader } from 'semantic-ui-react';
import { firstResponseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';

const CohortCountsLabelContainer = ({ readErrors, readStatus, children }) => {
  const error = firstResponseError(readErrors);
  return (
    <div className="float-r mr-10">
      {readStatus === states.PENDING && (
        <Loader active inline="centered" size="small" />
      )}
      {readStatus !== states.PENDING && error && (
        <Label size="small" basic color="red" content={error.message} />
      )}
      {readStatus !== states.PENDING && !error && (
      <div>
        { children }
      </div>
      )}
    </div>
  );
};

export default CohortCountsLabelContainer;
